function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUips(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("g", {
    fill: "#040000"
  }, React.createElement("path", {
    d: "M81.173 6.305H14.527c-6.904 0-12.496 5.592-12.496 12.496v41.654c0 6.904 5.592 12.496 12.496 12.496h29.158v8.331H31.188a4.165 4.165 0 000 8.33h33.323a4.165 4.165 0 000-8.33H52.015v-8.331h29.158c6.904 0 12.496-5.592 12.496-12.496V18.801c0-6.904-5.592-12.496-12.496-12.496zm4.165 54.15a4.164 4.164 0 01-4.165 4.166H14.527a4.164 4.164 0 01-4.165-4.166V18.801a4.164 4.164 0 014.165-4.165h66.646a4.164 4.164 0 014.165 4.165v41.654z"
  }), React.createElement("path", {
    d: "M61.066 25.844a3.74 3.74 0 00-5.288 0l-7.929 7.928-7.929-7.928a3.738 3.738 0 00-5.287 5.286l7.929 7.928-7.929 7.929a3.739 3.739 0 005.287 5.286l7.929-7.928 7.929 7.928a3.739 3.739 0 005.288-5.286l-7.93-7.929 7.93-7.928a3.739 3.739 0 000-5.286z"
  })));
}

SvgUips.clsName = 'icon-www__uips';
SvgUips.remarkName = 'unknown';
export default SvgUips;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uips.js
// module id = 2490
// module chunks = 17 18